import CoreuiController from "../lib/coreui-controller"
import Button from "../coreui/button"

export default class CoreuiButtonController extends CoreuiController {
  static Component = Button
}
